export const isBrowser = () => typeof window !== 'undefined';

export const getHostname = () => {
    if (!isBrowser()) return null;
    return window.location.hostname;
};

export const getRootDomain = () => {
    if (!isBrowser()) return null;

    const host = window.location.hostname;

    if (host === 'localhost') return 'localhost';

    if (/^\d{1,3}(\.\d{1,3}){3}$/.test(host)) return host;

    const parts = host.split('.');
    if (parts.length <= 2) return host;

    return parts.slice(-2).join('.');
};

export const getCookieDomain = () => {
    const root = getRootDomain();
    if (!root || root === 'localhost') return root;
    return `.${root}`;
};